import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2dbd1dc8&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=2dbd1dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd1dc8",
  null
  
)

export default component.exports